import React, { useState, useEffect } from 'react';
import './MyDesignsPage.css';
import config from '../config';

const API_BASE_URL = config.backendUrl;

const MyDesignsPage = ({ user, unityAuthData }) => {
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDesigns = async () => {
      if (!user || !unityAuthData) return;
      
      try {
        setLoading(true);
        setError(null);
        const token = localStorage.getItem('authToken');

        const response = await fetch(`${API_BASE_URL}/designs/${unityAuthData.playerId}`, {
          headers: {
            ...(token && { 'Authorization': `Bearer ${token}` }),
            'X-Unity-Token': unityAuthData.accessToken
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch designs');
        }

        const designsData = await response.json();
        console.log('Designs data:', designsData);

        // Ensure designsData.data exists and is an object
        const designsObj = designsData?.data || {};
        
        // Convert the object data to an array
        const designsArray = Object.entries(designsObj).map(([key, design]) => ({
          ...design,
          key // Add the key as a property in case we need it
        }));
        
        console.log('Designs array:', designsArray);
        setDesigns(designsArray);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching designs:', error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchDesigns();
  }, [user, unityAuthData]);

  const handleDesignClick = (designId) => {
    // Pseudocode for handling design click
    // This would typically open the design in the app or show more details
    console.log(`Design clicked: ${designId}`);
    
    // In a real implementation, you might redirect to a detail page
    // or trigger the Unity app to open this design
    // navigate(`/designs/${designId}`);
  };

  if (loading) {
    return (
      <div className="my-designs-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading your designs...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="my-designs-page">
        <div className="error-container">
          <h3>Something went wrong</h3>
          <p>{error}</p>
          <button onClick={() => window.location.reload()} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="my-designs-page">
      <div className="designs-header">
        <h2>My Designs</h2>
        <p className="designs-count">{designs.length} designs</p>
      </div>
      
      {designs.length === 0 ? (
        <div className="no-designs">
          <div className="empty-state-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7l10 5 10-5-10-5z" fill="currentColor"/>
              <path d="M2 17l10 5 10-5" fill="currentColor"/>
              <path d="M2 12l10 5 10-5" fill="currentColor"/>
            </svg>
          </div>
          <h3>No designs found</h3>
          <p>Your designs will appear here after you create and save them in the dream book 3D app.</p>
          {/* <button 
            onClick={() => window.open(`dreambook://launch?token=${unityAuthData?.accessToken}&playerId=${unityAuthData?.playerId}`, '_blank')}
            className="create-design-button"
            tabIndex="0"
            aria-label="Launch Dream Book 3D app"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                window.open(`dreambook://launch?token=${unityAuthData?.accessToken}&playerId=${unityAuthData?.playerId}`, '_blank');
              }
            }}
          >
            Launch Dream Book 3D
          </button> */}
        </div>
      ) : (
        <div className="designs-grid">
          {designs.map((design) => (
            <div 
              key={design.UID} 
              className="design-card"
              onClick={() => handleDesignClick(design.UID)}
              tabIndex="0"
              aria-label={`Design: ${design.Name}`}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleDesignClick(design.UID);
                }
              }}
            >
              <div className="thumbnail-container">
                <img 
                  src={`/images/house-thumbnails/${design.ModelName}_Thumbnail.webp`} 
                  alt={design.Name} 
                  className="design-thumbnail"
                  loading="lazy"
                />
              </div>
              <div className="design-info">
                <h3 className="design-name">{design.Name}</h3>
                <p className="design-date">
                  Last edited: {new Date(design.LastModified).toLocaleDateString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyDesignsPage;
